import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { IBaseSearchRequest, IPagedResults } from 'src/app/core/models/base';
import { ICreateWearingPartCategoryRequest, ICreateWearingPartCategoryResponse, IGetWearingPartCategoryResponse, IUpdateWearingPartCategoryRequest, IUpdateWearingPartCategoryResponse, IWearingPartCategory } from '../models/wearing-part-categories';

@Injectable({
  providedIn: 'root'
})
export class WearingPartCategoryService {

    constructor(private http: HttpClient) { }

    createWearingPartCategory(request: ICreateWearingPartCategoryRequest) {
        return this.http.post<ICreateWearingPartCategoryResponse>(
            `${environment.baseUrl}/v1/wearingPartCategories/createWearingPartCategory`,
            request
        )
    }

    getWearingPartCategories(request: IBaseSearchRequest){
        return this.http.post<IPagedResults<IWearingPartCategory[]>>(
          `${environment.baseUrl}/v1/wearingPartCategories/getWearingPartCategories`,
          request
        )
    }

    getWearingPartCategory(id: string){
        return this.http.get<IGetWearingPartCategoryResponse>(
          `${environment.baseUrl}/v1/wearingPartCategories/getWearingPartCategory/${id}`
        )
    }

    updateWearingPartCategory(request: IUpdateWearingPartCategoryRequest){
        return this.http.put<IUpdateWearingPartCategoryResponse>(
            `${environment.baseUrl}/v1/wearingPartCategories/updateWearingPartCategory/${request.id}`,
            request
        )
    }

    deleteWearingPartCategory(id :string){
        return this.http.delete(
            `${environment.baseUrl}/v1/wearingPartCategories/deleteWearingPartCategory/${id}`
        )
    }
}